var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pi-card-title",class:_vm.titleIcon +
    ' ' +
    _vm.size +
    ' ' +
    (_vm.titleIconPos == 'left' ? 'iscard' : '') +
    ' ' +
    (!_vm.titleIconShow ? 'no-icon' : ''),attrs:{"title":_vm.title}},[_vm._v(" "+_vm._s(_vm.title)),_vm._t("title")],2)}
var staticRenderFns = []

export { render, staticRenderFns }